<template>
  <div ref="rootRef">
    <keep-alive>
      <component 
        :is="elements"
        @update:cart="updateCart"
        @choose:assort="onProductChooseAssort"
        @choose:assortPromotion="onPromotionChooseAssort"
      ></component>
    </keep-alive>
    <PromotionProductChooseAssortDialog v-if="promotion" :is-bundle="hasBundle" :promotion="promotion" /> 
    <ProductChooseAssortDialog v-else :is-bundle="hasBundle" /> 
  </div>
</template>
<script setup>
import { computed, onMounted, toRaw, ref, h } from "vue";
import { useStore } from "vuex";
import { cloneDeep } from "lodash"
import {
  _api_getProduct,
  _api_getPromotionInfo,
} from "../../api/index.js";
import { renderHtml, getOptionsFromNode } from "../../plugins/html-to-vue/index.js";
import ProductChooseAssortDialog from "../lites/ProductChooseAssortDialog.vue"
import PromotionProductChooseAssortDialog from "../lites/PromotionProductChooseAssortDialog.vue"

import QuickPromotionElement from "./elements/QuickPromotionElement.vue"
import ManyGoodsElement from "./elements/ManyGoodsElement.vue"
import ManyPromotionElement from "./elements/ManyPromotionElement.vue"
import PromotionCodeElement from "./elements/PromotionCodeElement.vue"
import ImageElement from "./elements/ImageElement.vue"

const props = defineProps({
  data: String,
  dealerData: Object,
  distributor: Object,
  distributorLevels: Array,
  userData: Object,
  storeData: Object,
  isSubscribe: Number,
})

const store = useStore();
const storeData = computed(() => store.getters["lite/storeData"]);

const updateCart = () => {
  // console.warn('_SHOP_TOKEN_', Cookies.get("_SHOP_TOKEN_"));
  if (Cookies.get("_SHOP_TOKEN_")) {
    store.dispatch('lite/updateCart');
  }
}

const openChooseAssort = async (id) => {
  store.dispatch("lite/setFullPageLoading", true);
  try {
    console.log("openChooseAssort:", id)
    // 開啟選擇規格視窗
    const params = {
      fields: "dims,assorts,price_range,store_categories,supplier,brand",
    }
    const prod = await _api_getProduct(id, params)
    store.commit('lite/setProductChooseAssortDialog', {
      visible: true,
      data: prod,
      dataUpdateAt: +new Date(),
    });
    
  } catch (error) {
    notificationErrors(error)
  } finally {
    store.dispatch("lite/setFullPageLoading", false);
  }

  
}
const onPromotionChooseAssort =  (obj) => {
  promotion.value = obj?.promotion
  console.debug("開啟選擇規格視窗", obj)
  // openChooseAssort(prod)
  // console.log("onPromotionChooseAssort:", id, item)
  openChooseAssort(obj?.id)
}
const onProductChooseAssort = (id) => {
  promotion.value = null
  openChooseAssort(id)
}

const hasCart = ref(false)
const hasBundle = ref(false)
const elements = ref(null)
const rootRef = ref()
const promotion = ref(null)

const getElement = (node, key) => {
  return (
    node.type === 'tag' &&
    node.name === 'div' &&
    node.attrs?.['builder-element'] === key
  )
}
const onEvent = () => {
  return {
    "onUpdate:cart": () => updateCart(),
    "onChoose:assort": (id) => onProductChooseAssort(id),
    "onChoose:assortPromotion": (obj) => onPromotionChooseAssort(obj),
  }
}
// 插件內需取得購物車
const isCart = ["QuickPromotionElement"]
const isBundle = ["QuickPromotionElement"]

const extraComponents = () => {
  const extra = {}
  const items = [
    QuickPromotionElement, ManyGoodsElement, 
    ManyPromotionElement, PromotionCodeElement,
    ImageElement,
  ]

  items.forEach((key) => {
    const name = key.__name
    extra[name] = {
      conditions(node) {
        if (name === "ImageElement") {
          return (
            node.type === 'tag' &&
            node.name === 'img' &&
            node.attrs?.['builder-element'] === ""
          )
        }
        
        return getElement(node, name)
      },
      renderer(node, children, context) {
        if (isCart.includes(name)) {
          hasCart.value = true
          // console.debug("hasCart", name)
        }
        if (isBundle.includes(name)) {
          hasBundle.value = true
          // console.debug("hasCart", name)
        }
        
        return h(
          key,
          {
            attrs: node.attrs,
            ...onEvent(),
          },
          () => [...children],
        )
      },
    }
  })
  return extra
}

const parseBje = () => {
  const conf = {
    config: {
      container: {
        type: 'div'
      },
      extraComponentsMap: extraComponents(),
      textTransformer: text => text.trim()
    },

    rawHtml: props.data,
  }
  return renderHtml(conf.rawHtml, conf.config, conf.rawHtml)
}

onMounted(() => {
  // console.warn('_SHOP_TOKEN_', Cookies.get("_SHOP_TOKEN_"));

  store.commit('lite/setStoreData', props.storeData);
  store.commit('lite/setDealerData', props.dealerData);
  store.commit('lite/setIsSubscribe', props.isSubscribe);
  store.commit('lite/setDistributorData', props.distributor);
  store.commit('lite/setDistributorLevels', props.distributorLevels);

  const userData = cloneDeep(props.userData);
  store.commit('lite/setUserData', userData);

  elements.value = parseBje()
  if (hasCart.value) {
    updateCart();
  }

  // 登入後自動開啟「開始結帳」
  if (window.localStorage.getItem('liteAutoOpenCheckoutDialogLogonCallback')) {
    localStorage.removeItem('liteAutoOpenCheckoutDialogLogonCallback');
    if (userData?.id) {
      store.dispatch('lite/openCheckoutDialog');
    }
  }
})
</script>
